var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAadhar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F6F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 16.75C19.25 16.4048 19.5298 16.125 19.875 16.125H23C23.3452 16.125 23.625 16.4048 23.625 16.75C23.625 17.0952 23.3452 17.375 23 17.375H19.875C19.5298 17.375 19.25 17.0952 19.25 16.75Z",
    fill: "#606DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 19.25C19.25 18.9048 19.5298 18.625 19.875 18.625H23C23.3452 18.625 23.625 18.9048 23.625 19.25C23.625 19.5952 23.3452 19.875 23 19.875H19.875C19.5298 19.875 19.25 19.5952 19.25 19.25Z",
    fill: "#606DD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1954 16.125C14.5051 16.125 13.9454 16.6846 13.9454 17.375C13.9454 18.0654 14.5051 18.625 15.1954 18.625C15.8858 18.625 16.4454 18.0654 16.4454 17.375C16.4454 16.6846 15.8858 16.125 15.1954 16.125ZM12.6954 17.375C12.6954 15.9943 13.8147 14.875 15.1954 14.875C16.5761 14.875 17.6954 15.9943 17.6954 17.375C17.6954 18.7557 16.5761 19.875 15.1954 19.875C13.8147 19.875 12.6954 18.7557 12.6954 17.375Z",
    fill: "#606DD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1953 19.8701C14.779 19.8701 14.3745 20.0087 14.0456 20.264C13.7167 20.5192 13.4821 20.8767 13.3789 21.28C13.2933 21.6144 12.9528 21.8161 12.6184 21.7305C12.284 21.6449 12.0823 21.3044 12.1679 20.97C12.34 20.2978 12.731 19.702 13.2791 19.2765C13.8272 18.8511 14.5014 18.6201 15.1953 18.6201C15.8892 18.6201 16.5633 18.8511 17.1114 19.2765C17.6596 19.702 18.0505 20.2978 18.2226 20.97C18.3082 21.3044 18.1066 21.6449 17.7722 21.7305C17.4378 21.8161 17.0973 21.6144 17.0117 21.28C16.9084 20.8767 16.6739 20.5192 16.345 20.264C16.0161 20.0087 15.6116 19.8701 15.1953 19.8701Z",
    fill: "#606DD2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 12.375C9.875 11.6846 10.4346 11.125 11.125 11.125H24.875C25.5654 11.125 26.125 11.6846 26.125 12.375V23.625C26.125 24.3154 25.5654 24.875 24.875 24.875H11.125C10.4346 24.875 9.875 24.3154 9.875 23.625V12.375ZM24.875 12.375H11.125V23.625H24.875V12.375Z",
    fill: "#606DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhar);
export default __webpack_public_path__ + "static/media/aadhar.d872d3cd29735001bb8161cef93c3dcf.svg";
export { ForwardRef as ReactComponent };